// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { tbVector } from "../../engine/tbVector";
import { tgfFunctions } from "../../framework/tgfFunctions";
import { PhysicsSettings } from "../../settings/PhysicsSettings";
import { blockFactory, physics } from "../SceneController";
import { BirdObjectDefault } from "./BirdObject";
export function BirdObjectBlue(def, uid, x, y, angle, container) {
    BirdObjectBlue.uber.constructor.call(this, def, uid, x, y, angle, container);
    this.original = true;
}
tgfFunctions.inherit(BirdObjectBlue, BirdObjectDefault);
BirdObjectBlue.prototype.activateSpecialPower = function (arrayOfBirds) {
    if (this.canUsePower && !this.firstContact) {
        this.playSound(this.soundStates.ABILITY, this.definition.sounds);
        this.canUsePower = false;
        var dir = new tbVector(this.velocity.x, this.velocity.y).normalize();
        var perp = dir.perpendicular();
        var spread = PhysicsSettings.blueBirdSpread;
        var origins = [];
        origins.push(new tbVector(this.x, this.y));
        origins.push(origins[0].add(perp.scale(spread)));
        origins.push(origins[0].add(perp.scale(-spread)));
        var velocities = [];
        velocities.push(new tbVector(this.velocity.x, this.velocity.y));
        velocities.push(velocities[0].rotate(PhysicsSettings.blueBirdAngleDeviation));
        velocities.push(velocities[0].rotate(-PhysicsSettings.blueBirdAngleDeviation));
        this.clones = [];
        for (var i = 0; i < origins.length; i++) {
            var clone = blockFactory("BlueBird", -1, origins[i].x, origins[i].y, 0, this.container);
            clone.canUsePower = false;
            clone.original = false;
            clone.body.SetActive(true);
            physics.setVelocity(clone.body, velocities[i].x, velocities[i].y);
            //when the clone is moving left, flip its animation vertically, so that it will be rendered correctly, instead of up-side-down.
            if (velocities[i].x < 0) {
                clone.image.flipVertically();
            }
            arrayOfBirds.push(clone);
        }
        this.destroy();
        arrayOfBirds.splice(arrayOfBirds.indexOf(this), 1);
        return true;
    }
    return false;
};
BirdObjectBlue.prototype.destroyEffect = function () {
    "use strict";
    if (this.original) {
        return;
    }
    BirdObjectBlue.uber.destroyEffect.call(this);
};
BirdObjectBlue.prototype.spineInit = function () {
    "use strict";
};
